import { MappedClass, MappedProperty } from '@h5s/util-object';

@MappedClass()
export class ZPrinterStatus {
  @MappedProperty()
  is_cover_open?: boolean;

  @MappedProperty()
  is_paper_nearly_empty?: boolean;

  @MappedProperty()
  is_paper_over?: boolean;
}
